import { FC } from 'react';
import { LiveActivityContainer } from './LiveActivity.style';

export const ActivityLoader: FC = () => (
	<LiveActivityContainer className="flex items-center justify-center rounded-3xl border bg-white px-16 py-1">
		<div role="status" className="max-w-sm animate-pulse rounded  p-4">
			<div>
				<div className="mb-4 flex flex-row items-center gap-4">
					<div className=" h-16 w-16 rounded-2xl bg-gray-200"></div>
					<div className="flex flex-col gap-2">
						<div className="h-6 w-40 rounded-full bg-gray-200 dark:bg-gray-700 xl:w-60"></div>
						<div className="h-2 w-32 rounded-full bg-gray-200 dark:bg-gray-700 xl:w-48"></div>
					</div>
				</div>
				<div className="w-full">
					<div className="mb-2.5 h-2 max-w-[480px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
					<div className="mb-2.5 h-2 max-w-[460px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
					<div className="h-2 max-w-[360px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
				</div>

				<div className="mt-4 flex items-center justify-between">
					<div className="flex flex-row gap-2">
						<div className="h-6 w-6 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
						<div className="h-6 w-6 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
						<div className="h-6 w-6 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
						<div className="h-6 w-6 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
					</div>
					<div className="h-6 w-16 rounded bg-gray-200 dark:bg-gray-700 xl:w-36"></div>
				</div>
			</div>
		</div>
	</LiveActivityContainer>
);
